(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('MachineSearch', MachineSearch);

    MachineSearch.$inject = ['$resource'];

    function MachineSearch($resource) {
        var resourceUrl =  'api/_search/machines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
